import service from '@/utils/request'
let { getRequestJson, postRequestJson } = service;

// 登录
export function login(data) {
  return postRequestJson('/auth/login', data)
}

// 登出
export function logout() {
  return postRequestJson('/auth/logout')
}

// 获取当前登录用户信息
export function getUserInfo() {
  return getRequestJson('/user/info')
}

// 创建用户
export function addUser(data) {
  return postRequestJson('/user/create', data)
}

// 更新用户
export function updateUser(data) {
  return postRequestJson('/user/update', data)
}

// 启用禁用用户
export function changeUserEnable(data) {
  return postRequestJson('/user/enable', data)
}

// 修改密码
export function changePassword(data) {
  return postRequestJson('/user/updatePassword', data)
}

// 查询用户列表（分页）
export function getUserList(params) {
  return getRequestJson('/user/page', params)
}
